// The review link a positive guest got, worked out the way the traveller review page does:
// handleOTARedirectURL is a copy of reviews_app src/utils/handleOTALogic.js. Keep the two in sync.
//
// The copy keeps the review app's behaviour as it is, because the Ratings grid must show what the
// guest actually got. Since CP-7040 (2026-02-10) the review page API sends the guest's reseller
// without its id, so target 0 ("reseller or URL") never picks the reseller's review page.
export const handleOTARedirectURL = (response_data) => {
    const review_target = response_data.positive_review_target;
    let redirect_url = null;

    if (review_target === 0) {
        if (response_data.user?.ota?.id) {
            redirect_url = response_data.user?.ota?.review_url;
        }
        if (!redirect_url) {
            // default to provided positive review url
            redirect_url = response_data.positive_review_url;
        }
    }
    if (review_target === 1) {
        if (response_data.user?.ota) {
            redirect_url = response_data.user?.ota?.review_url;
        }
    }
    if (review_target === 2) {
        redirect_url = response_data.positive_review_url;
        if (!redirect_url) {
            // default to provided positive review url
            redirect_url = response_data.tour?.review?.url || response_data.tour?.tour_operator?.review?.url;
        }
    }
    if (review_target === 3) {
        // redirect url stays null
    }

    return redirect_url;
};

const POSITIVE_REVIEW_URL_SOURCE_CUSTOM = 1;

// { url, direct } for a positive review, or null: a negative rating, no link, or an operator on the
// custom URL template (CP-8403), which the review page renders per guest and the grid does not have.
// `direct`: the operator's "Direct to link", so the guest was sent there right after rating.
export const positiveReviewLink = (row, fallbackThreshold) => {
    const threshold = Number(row.low_high_threshold) || fallbackThreshold;
    if (!(Number(row.star_rating) >= threshold)) return null;
    if (+row.positive_review_url_source === POSITIVE_REVIEW_URL_SOURCE_CUSTOM) return null;
    const tour = row.participant?.tour;
    const url = handleOTARedirectURL({
        positive_review_target: tour?.positive_review_target,
        positive_review_url: tour?.positive_review_url,
        user: row.participant?.user,
        tour,
    });
    return url ? { url, direct: !!row.positive_review_direct_link } : null;
};
